import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-emailSendSuccess",
  "use": "icon-emailSendSuccess-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-emailSendSuccess\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 531.5l-396 396-56.5 56.5-56.6-56.6L324 736.5l56.6-56.6 190.9 190.9 396-396 56.5 56.7zM114 842h159.9v50H64V132h896v286.2h-50v-20.7L512 614 114 397.5V842z m0-501.4l398 216.5 398-216.5V182H114v158.6z\" fill=\"\" p-id=\"3458\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/emailSendSuccess.svg
// module id = Vnua
// module chunks = 48